"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var bus_rdf_resolve_quad_pattern_1 = require("@comunica/bus-rdf-resolve-quad-pattern");

var utils_datasource_1 = require("@comunica/utils-datasource");

var asynciterator_1 = require("asynciterator");

var fetch_sparql_endpoint_1 = require("fetch-sparql-endpoint");

var rdf_string_1 = require("rdf-string");

var sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * A comunica SPARQL Endpoint Query Operation Actor.
 */


var ActorQueryOperationSparqlEndpoint =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationSparqlEndpoint, _bus_query_operation_);

  function ActorQueryOperationSparqlEndpoint(args) {
    var _this;

    _classCallCheck(this, ActorQueryOperationSparqlEndpoint);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationSparqlEndpoint).call(this, args));
    _this.endpointFetcher = new fetch_sparql_endpoint_1.SparqlEndpointFetcher({
      fetch: function fetch(input, init) {
        return _this.mediatorHttp.mediate({
          input: input,
          init: init,
          context: _this.lastContext
        });
      },
      prefixVariableQuestionMark: true
    });
    return _this;
  }
  /**
   * Wrap a pattern in a select query.
   * @param {Operation} operation An operation.
   * @return {Project} A select query.
   */


  _createClass(ActorQueryOperationSparqlEndpoint, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        var source;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (action.operation) {
                  _context.next = 2;
                  break;
                }

                throw new Error('Missing field \'operation\' in the query operation action: ' + require('util').inspect(action));

              case 2:
                _context.next = 4;
                return utils_datasource_1.DataSourceUtils.getSingleSource(action.context);

              case 4:
                source = _context.sent;

                if (!(source && bus_rdf_resolve_quad_pattern_1.getDataSourceType(source) === 'sparql')) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", {
                  httpRequests: 1
                });

              case 7:
                throw new Error(this.name + ' requires a single source with a \'sparql\' endpoint to be present in the context.');

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        var endpoint, selectQuery, query, bindingsStream, metadata;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = bus_rdf_resolve_quad_pattern_1;
                _context2.next = 3;
                return utils_datasource_1.DataSourceUtils.getSingleSource(action.context);

              case 3:
                _context2.t1 = _context2.sent;
                endpoint = _context2.t0.getDataSourceValue.call(_context2.t0, _context2.t1);
                selectQuery = ActorQueryOperationSparqlEndpoint.patternToSelectQuery(action.operation);
                query = sparqlalgebrajs_1.toSparql(selectQuery);
                bindingsStream = new asynciterator_1.BufferedIterator({
                  autoStart: false,
                  maxBufferSize: Infinity
                });
                this.lastContext = action.context;
                this.endpointFetcher.fetchBindings(endpoint, query).then(function (rawBindingsStream) {
                  var totalItems = 0;
                  rawBindingsStream.on('error', function (error) {
                    return bindingsStream.emit('error', error);
                  });
                  rawBindingsStream.on('data', function (rawBindings) {
                    totalItems++;

                    bindingsStream._push(bus_query_operation_1.Bindings(rawBindings));
                  });
                  rawBindingsStream.on('end', function () {
                    bindingsStream.emit('metadata', {
                      totalItems: totalItems
                    });
                    bindingsStream.close();
                  });
                });
                metadata = ActorQueryOperationSparqlEndpoint.cachifyMetadata(function () {
                  return new Promise(function (resolve, reject) {
                    bindingsStream._fillBuffer();

                    bindingsStream.on('error', reject);
                    bindingsStream.on('end', function () {
                      return reject(new Error('No metadata was found'));
                    });
                    bindingsStream.on('metadata', resolve);
                  });
                });
                return _context2.abrupt("return", {
                  type: 'bindings',
                  metadata: metadata,
                  bindingsStream: bindingsStream,
                  variables: selectQuery.variables.map(rdf_string_1.termToString)
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }], [{
    key: "patternToSelectQuery",
    value: function patternToSelectQuery(operation) {
      if (operation.type === 'project') {
        return operation;
      }

      var variables = sparqlalgebrajs_1.Util.inScopeVariables(operation);
      return ActorQueryOperationSparqlEndpoint.FACTORY.createProject(operation, variables);
    }
  }]);

  return ActorQueryOperationSparqlEndpoint;
}(bus_query_operation_1.ActorQueryOperation);

ActorQueryOperationSparqlEndpoint.FACTORY = new sparqlalgebrajs_1.Factory();
exports.ActorQueryOperationSparqlEndpoint = ActorQueryOperationSparqlEndpoint;